import { WidgetContainerService } from "./services/widget-container.service.js";
import { WidgetErrorService } from "./services/widget-error.service.js";
import { WidgetDisposeService } from "./services/widget-remove.service.js";

export class Widget {
  constructor(dispatch, getState, initTimer) {
    this._containerService = new WidgetContainerService(dispatch, getState);
    this._errorService = new WidgetErrorService(dispatch);
    this._disposeService = new WidgetDisposeService(dispatch, initTimer);
  }

  handleCreateContainer = () => {
    this._containerService.handleCreate();
  };

  handleToggleContainer = () => {
    this._containerService.handleToggle();
  };

  handleDispose = () => {
    this._disposeService.handle();
  };

  handleError = () => {
    this._errorService.handle();
  };
}
